<template>
    <CustomDialog
        :value="value"
        @input="$emit('input', $event)"
        :defaultTitle="$t('profil.edit_profile')"
        :heightClass="`ppv2-max-h-[85vh]`"
        height="auto"
        centerContent
    >
        <template #content>
            <div class="ppv2-grid ppv2-grid-cols-2" :style="{ gap: normalizeSize(16, true) }">
                <!-- Prénom -->
                <BaseInput
                    v-model="form.first_name"
                    :label="$t('profil.first_name.label')"
                    :placeholder="$t('profil.first_name.placeholder')"
                    required
                    classContainerAdd="ppv2-w-full"
                    :error="errors.first_name"
                />

                <!-- Nom -->
                <BaseInput
                    v-model="form.last_name"
                    :label="$t('profil.last_name.label')"
                    :placeholder="$t('profil.last_name.placeholder')"
                    required
                    classContainerAdd="ppv2-w-full"
                    :error="errors.last_name"
                />

                <!-- Email -->
                <BaseInput
                    v-model="form.email"
                    type="email"
                    :label="$t('profil.email.label')"
                    :placeholder="$t('profil.email.placeholder')"
                    required
                    classContainerAdd="ppv2-w-full"
                    :error="errors.email"
                />

                <!-- Téléphone -->
                <BaseInput
                    v-model="form.phone_number"
                    :label="$t('profil.phone_number.label')"
                    :placeholder="$t('profil.phone_number.placeholder')"
                    classContainerAdd="ppv2-w-full"
                    :error="errors.phone_number"
                    required
                />
            </div>
        </template>
        <template #actions>
            <BaseButton
                variant="primary"
                @click="save"
                :customClass="`!ppv2-h-[45px] !ppv2-min-w-[170px] !ppv2-bg-[#7D2DBD]`"
                :disabled="isSaving"
            >
                {{ isSaving ? $t('common.saving') : $t('common.validate') }}
            </BaseButton>
        </template>
    </CustomDialog>
</template>

<script>
import normalizeSize from '../../../utils/normalizeSize'

import BaseButton from '../../Shared/BaseButton.vue'
import BaseInput from '../../Shared/BaseInput.vue'
import CustomDialog from '../../Shared/CustomDialog.vue'

export default {
    name: 'ProfileEditModal',
    components: {
        BaseButton,
        BaseInput,
        CustomDialog,
    },
    props: {
        value: { type: Boolean, required: true },
        initialData: { type: Object, default: () => ({}) },
        isSaving: { type: Boolean, default: false },
        errors: { type: Object, default: () => ({}) },
    },
    data() {
        return {
            form: {
                first_name: '',
                last_name: '',
                email: '',
                phone_number: '',
            },
        }
    },
    watch: {
        value(val) {
            if (val) {
                this.initializeForm()
            }
        },
        initialData: {
            handler() {
                if (this.value) {
                    this.initializeForm()
                }
            },
            deep: true,
        },
    },
    methods: {
        normalizeSize,
        initializeForm() {
            this.form = {
                first_name: this.initialData.first_name || '',
                last_name: this.initialData.last_name || '',
                email: this.initialData.email || '',
                phone_number: this.initialData.phone_number || '',
            }
        },
        save() {
            this.$emit('save', this.form)
        },
    },
}
</script>
